module.exports = __webpack_public_path__ + "static/media/team-illustration-2.8143c009.svg";